import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8baaac4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-page" }
const _hoisted_2 = { class: "map-overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EleosMap = _resolveComponent("EleosMap")!
  const _component_SomethingWrongOverlay = _resolveComponent("SomethingWrongOverlay")!
  const _component_DirectionsSent = _resolveComponent("DirectionsSent")!
  const _component_NearbyTrailerResultsList = _resolveComponent("NearbyTrailerResultsList")!
  const _component_SelectedLocationBubble = _resolveComponent("SelectedLocationBubble")!
  const _component_CustomerTrailerList = _resolveComponent("CustomerTrailerList")!
  const _component_DriverFeedback = _resolveComponent("DriverFeedback")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_EleosMap, {
        points: _ctx.points,
        latitude: _ctx.mapLatitude,
        longitude: _ctx.mapLongitude,
        selectedResult: _ctx.selectedResult,
        onSetSelectedResult: _ctx.setSelectedResult,
        shouldFitMapView: true
      }, null, 8, ["points", "latitude", "longitude", "selectedResult", "onSetSelectedResult"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.hasError && !_ctx.isDetachError)
        ? (_openBlock(), _createBlock(_component_SomethingWrongOverlay, {
            key: 0,
            message: _ctx.error?.message
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      (_ctx.directionsModalShown)
        ? (_openBlock(), _createBlock(_component_DirectionsSent, {
            key: 1,
            onModalClosed: _ctx.hideDirectionsModal
          }, null, 8, ["onModalClosed"]))
        : (!_ctx.locationSelected && !_ctx.isViewingCustomerTrailers)
          ? (_openBlock(), _createBlock(_component_NearbyTrailerResultsList, {
              key: 2,
              isLoading: _ctx.loading,
              isRefreshing: _ctx.isRefreshing,
              onSetSelectedResult: _ctx.setSelectedResult
            }, null, 8, ["isLoading", "isRefreshing", "onSetSelectedResult"]))
          : (!_ctx.isViewingCustomerTrailers)
            ? (_openBlock(), _createBlock(_component_SelectedLocationBubble, {
                key: 3,
                onBackToListView: _ctx.backToListView,
                onNavigationSent: _ctx.navigationSent,
                selectedResult: _ctx.selectedResult,
                onSetSelectedResult: _ctx.setSelectedResult,
                onDisplayCustomerTrailers: _ctx.onDisplayCustomerTrailers
              }, null, 8, ["onBackToListView", "onNavigationSent", "selectedResult", "onSetSelectedResult", "onDisplayCustomerTrailers"]))
            : _createCommentVNode("", true),
      (_ctx.isViewingCustomerTrailers)
        ? (_openBlock(), _createBlock(_component_CustomerTrailerList, {
            key: 4,
            results: _ctx.customerTrailers,
            onNavigateBack: _ctx.onNavigateBackFromCustomerList
          }, null, 8, ["results", "onNavigateBack"]))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_DriverFeedback, {
            key: 5,
            trailers: _ctx.nearbyTrailerResults,
            viewName: _ctx.viewName
          }, null, 8, ["trailers", "viewName"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}